import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UtilService {
  /** Llaves de un objeto, util para iterar con @for en las plantillas. */
  objectKeys(value: Record<string, unknown> | null | undefined): string[] {
    return value ? Object.keys(value) : [];
  }

  /** Copia un texto al portapapeles. Devuelve true si lo logro. */
  async copyToClipboard(text: string): Promise<boolean> {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      return false;
    }
  }

  /**
   * Arma los query params ignorando null / undefined / cadena vacia.
   * OJO: las llaves de paginacion del API van en snake_case (`page_size`).
   */
  buildParams(params: Record<string, string | number | boolean | null | undefined>): HttpParams {
    let httpParams = new HttpParams();
    for (const key of Object.keys(params)) {
      const value = params[key];
      if (value === null || value === undefined || value === '') continue;
      httpParams = httpParams.set(key, String(value));
    }
    return httpParams;
  }

  /** Mensaje legible a partir de cualquier error de HttpClient. */
  errorMessage(error: unknown, fallback = 'Ocurrio un error inesperado.'): string {
    const body = (error as { error?: unknown })?.error;
    if (typeof body === 'string' && body) return body;
    const envelopeMessage = (body as { message?: string })?.message;
    if (envelopeMessage) return envelopeMessage;
    const detail = (body as { detail?: string })?.detail;
    if (detail) return detail;
    const message = (error as { message?: string })?.message;
    return message || fallback;
  }
}
